import styled from 'styled-components';

export const SelectMallContainer = styled.div`
  padding-bottom: 40px;

  p.notice {
    padding: 40px 35px;
    line-height: 22px;
    font-size: 17px;
  }

  section {
    margin-bottom: 50px;
    padding: 0 35px;

    & > p {
      margin-bottom: 15px;
      font-size: 14px;
      font-weight: 600;
    }

    ul {
      display: flex;
      flex-wrap: wrap;
      gap: 15px 8%;

      li {
        width: calc((100% - 16%) / 3);
        list-style: none;
        margin-left: 0;
        cursor: pointer;

        div {
          margin-bottom: 15px;
          height: 90px;
          display: flex;
          background-color: #f1f1f1;
          border-radius: 10px;
          justify-content: center;
          align-items: center;
        }

        img {
          width: 50px;
          height: 50px;
        }

        p {
          margin-bottom: 3px;
          font-size: 12px;
          text-align: center;
        }
      }
    }
  }
`;
